<template>
    <div class="panel-container show">
        <div class="panel-content">
            <div class="d-flex flex-column align-items-center justify-content-center p-4">
                <h5 class="mb-0 fw-700 text-center mt-3" v-if="this.location.id > 0">
                    {{this.location.title}}
                </h5>

                <h5 class="mb-0 fw-700 text-center mt-3" v-else>
                    {{__t("NEW_REST")}}
                </h5>
            </div>
            <div>
                <div class="form-group mt-2">
                    <label class="form-label" for="advanced_name">
                        {{__t("REST_NAME")}}
                    </label>

                    <div class="input-group flex-nowrap">
                        <div class="input-group-prepend">
							<span class="input-group-text">
								<i class="fal  fa-typewriter fs-xl" ></i>
							</span>
                        </div>
                        <input id="advanced_name" type="text" class="form-control" v-model="location.title">
                    </div>
                </div>

                <!-- Location PARAMS -->
                <div class="panel-tag mt-2">
                    {{__t("BOLT_LOCATION_PARAMS")}}
                </div>

                <div class="form-group mt-2" v-for="general_field in general_fields">
                    <label class="form-label" >
                        {{general_field.title}}
                    </label>

                    <div class="input-group flex-nowrap">
                        <div class="input-group-prepend">
							<span class="input-group-text">
								<i class="fal  fa-typewriter fs-xl" ></i>
							</span>
                        </div>
                        <input :id="general_field.key" type="text" class="form-control" v-model="location.general_fields[general_field.key]">
                    </div>
                </div>

                <location_general_params :location="location"></location_general_params>
            </div>
        </div>
    </div>
</template>

<script>
import Location_general_params from "../../../base/location_general_tab/location_general_params.vue";
export default {
    name: "bolt_general_tab",

    components : {
        Location_general_params,
    },

    props : {
        location : {
            type : Object
        }
    },

    data() {
        return {

        }
    },

    computed: {
        general_fields() {
            if(this.location.hasOwnProperty("general_fields")) {
                let res = [];
                for (const [key, value] of Object.entries(this.location.general_fields)) {
                    if(key != 'id') {
                        res.push({
                            key: key,
                            value: value,
                            title: this.__t(key.toUpperCase())
                        });
                    }
                }

                return res;
            }
            return [];
        },

    }
}
</script>

<style scoped>

</style>
